import { useTranslations } from '@i18n/useLanguage'
import { SectionHeader } from '@app/components/blocks/sectionHeader/SectionHeader'
import { pages } from '@app/util/links'
import { useQuery } from '@based/sdk/react'
import { useMemo } from 'react'
import type { InitiativeSpotlightModel } from 'functions/app/spotlight/list'
import type { ListInitiativeModel } from 'functions/app/initiative/list'
import Column from '@app/components/layout/Column'
import { SpotlightInitiativeGrid } from '@app/components/blocks/spotlightInitiativeGrid/SpotlightInitiativeGrid'

/** Max initiatives shown in the landing discover spotlight grid (shared with query limits). */
export const LANDING_SPOTLIGHT_INITIATIVE_COUNT = 5

export const DiscoverSection = () => {
  const t = useTranslations().app
  const spotlightQuery = useQuery('list-spotlight', {
    entityType: 'initiative',
    limit: LANDING_SPOTLIGHT_INITIATIVE_COUNT,
  })
  const initiativeQuery = useQuery('list-initiative', {
    top: LANDING_SPOTLIGHT_INITIATIVE_COUNT,
    desc: true,
  })

  const initiatives: ListInitiativeModel[] = useMemo(() => {
    const spotlights: InitiativeSpotlightModel[] = spotlightQuery.data || []

    const fallbackInitiatives: ListInitiativeModel[] =
      initiativeQuery.data || []

    const spotlighted = spotlights.map((s) => s.initiative)

    if (spotlighted.length === LANDING_SPOTLIGHT_INITIATIVE_COUNT) {
      return spotlighted
    }

    const nonDuplicated = fallbackInitiatives.filter(
      (fi) => spotlighted.findIndex((i) => i.uuid === fi.uuid) === -1,
    )

    return [...spotlighted, ...nonDuplicated].slice(
      0,
      LANDING_SPOTLIGHT_INITIATIVE_COUNT,
    )
  }, [spotlightQuery.data, initiativeQuery.data])

  return (
    <Column alignItems="stretch">
      <SectionHeader
        title={t.landingPage.discoverSection.title}
        subtitle={t.landingPage.discoverSection.subTitle}
        seeMore={t.landingPage.discoverSection.seeMore}
        toRoute={pages.initiatives}
      />

      <SpotlightInitiativeGrid
        initiatives={initiatives}
        notSpecified={t.common.notSpecified}
        searchingForMembersLabel={
          t.common.initiativeStatus.searchingForMembers
        }
        notSearchingForMembersLabel={
          t.common.initiativeStatus.notSearchingForMembers
        }
      />
    </Column>
  )
}
